var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('mu-circular-progress',{attrs:{"size":32,"stroke-width":2}}),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }